var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"summary-section",staticClass:"summary-section"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('main.details-tabs.summary')))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.getLocaleString(_vm.game.about))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }